import React, { useState } from 'react';
import Globe from '../components/travel/Globe';
import ReactCountryFlag from 'react-country-flag';
import AnimatedPage from '../components/animatedPage/AnimatedPage';

const visitedCountries = [
  { id: 'PRT', name: 'Portugal', code: 'PT' },
  { id: 'ESP', name: 'Spain', code: 'ES' },
  { id: 'FRA', name: 'France', code: 'FR' },
  { id: 'ITA', name: 'Italy', code: 'IT' },
  { id: 'DEU', name: 'Germany', code: 'DE' },
  { id: 'POL', name: 'Poland', code: 'PL' },
  { id: 'KAZ', name: 'Kazakhstan', code: 'KZ' },
  { id: 'UZB', name: 'Uzbekistan', code: 'UZ' },
  { id: 'HUN', name: 'Hungary', code: 'HU' },
  { id: 'CZE', name: 'Czech Republic', code: 'CZ' },
  { id: 'SVK', name: 'Slovakia', code: 'SK' },
  { id: 'AUT', name: 'Austria', code: 'AT' },
  { id: 'GRC', name: 'Greece', code: 'GR' },
  { id: 'CYP', name: 'Cyprus', code: 'CY' },
  { id: 'TUR', name: 'Turkey', code: 'TR' },
  { id: 'SWE', name: 'Sweden', code: 'SE' },
  { id: 'FIN', name: 'Finland', code: 'FI' },
  { id: 'NOR', name: 'Norway', code: 'NO' },
  { id: 'EST', name: 'Estonia', code: 'EE' },
  { id: 'LTU', name: 'Lithuania', code: 'LT' },
  { id: 'LVA', name: 'Latvia', code: 'LV' },
  { id: 'ISR', name: 'Israel', code: 'IL' },
  { id: 'KGZ', name: 'Kyrgyzstan', code: 'KG' },
  { id: 'CHN', name: 'China', code: 'CN' },
  { id: 'CHE', name: 'Switzerland', code: 'CH' },
  { id: 'ROU', name: 'Romania', code: 'RO' },
  { id: 'JPN', name: 'Japan', code: 'JP' },
  { id: 'NLD', name: 'Netherlands', code: 'NL' },
];

export const countryCategories = [
  {
    label: 'Where I live',
    color: '#FF6B6B',
    countries: ['PRT'],
  },
  {
    label: "Where I've lived",
    color: '#FFD93D',
    countries: ['POL'],
  },
  {
    label: "Where I've been more than once",
    color: '#6BCB77',
    countries: ['ESP', 'ITA', 'TUR', 'HUN', 'DEU', 'KAZ', 'NOR'],
  },
  {
    label: "Where I've been",
    color: '#4D96FF',
    countries: ['FRA', 'UZB', 'CZE', 'SVK', 'AUT', 'GRC', 'CYP', 'SWE', 'FIN', 'EST', 'LTU', 'LVA', 'ISR', 'KGZ', 'CHN', 'CHE', 'ROU', 'JPN', 'NLD'],
  },
];

// Build a flat map of { countryId -> color } for easy lookup in Globe
export const countryColorMap = countryCategories.reduce((acc, category) => {
  category.countries.forEach((id) => {
    acc[id] = category.color;
  });
  return acc;
}, {});

const Travels = () => {
  const [hoveredCountry, setHoveredCountry] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);

  return (
    <AnimatedPage>
      <main className="section">
<div className="container">
  <div className="globe-container">
    <Globe
      visitedCountries={visitedCountries}
      countryColorMap={countryColorMap}
      onHoverCountry={setHoveredCountry}
      onSelectCountry={setSelectedCountry}
    />

    {/* Country caption */}
    <div className="globe-caption">
      {countryCategories.map((category) => (
        <div key={category.label} className="globe-caption-group">
          <span className="globe-caption-label">
            <span
              className="globe-caption-color-dot"
              style={{ backgroundColor: category.color }}
            />
            {category.label}
          </span>
          <div className="globe-caption-flags">
            {category.countries.map((id) => {
              const country = visitedCountries.find((c) => c.id === id);
              return (
                <div key={id} className="globe-caption-flag-item" title={country.name}>
                  <ReactCountryFlag countryCode={country.code} svg title={country.name} />
                  <span className="globe-caption-country-name">{country.name}</span>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  </div>

  {/* Hover/select display — now outside globe-container */}
  <div className="globe-selected-country-description">
    <div className="title-2">
      {selectedCountry ? (
        <>
          {selectedCountry.properties.name}
          <ReactCountryFlag
            countryCode={visitedCountries.find((c) => c.id === selectedCountry.id).code}
            svg
          />
        </>
      ) : hoveredCountry ? (
        <>
          {hoveredCountry.properties.name}
          <ReactCountryFlag
            countryCode={visitedCountries.find((c) => c.id === hoveredCountry.id).code}
            svg
          />
        </>
      ) : (
        'Hover over a country!'
      )}
    </div>
  </div>

</div>
      </main>
    </AnimatedPage>
  );
};

export default Travels;